import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { ExternalCourseCertificate } from '../../models/externalCourseCertificate.model'

import {
  ExternalCourseParticipantsListParams,
  GetListResponse,
} from 'api/administration/externalCourseParticipants/GetList'

export const EXTERNAL_COURSE_CERTIFICATES_GET_LIST =
  'EXTERNAL_COURSE_CERTIFICATES_GET_LIST'
export const EXTERNAL_COURSE_CERTIFICATES_GET_LIST_SUCCESS =
  'EXTERNAL_COURSE_CERTIFICATES_GET_LIST_SUCCESS'
export const EXTERNAL_COURSE_CERTIFICATES_LOADING =
  'EXTERNAL_COURSE_CERTIFICATES_LOADING'
export const DESTROY_EXTERNAL_COURSE_CERTIFICATES =
  'DESTROY_EXTERNAL_COURSE_CERTIFICATES'

export interface DestroyExternalCourseCertificatesPayload {
  ids: (number | string)[]
  externalCourseId?: number | string
  params?: ExternalCourseParticipantsListParams
  callback?(resList: GetListResponse): void
}

export const Actions = {
  getList: () => createAction(EXTERNAL_COURSE_CERTIFICATES_GET_LIST),
  setListSuccess: (data: ExternalCourseCertificate[]) =>
    createAction(EXTERNAL_COURSE_CERTIFICATES_GET_LIST_SUCCESS, {
      data,
    }),
  setLoading: (loading: boolean) =>
    createAction(EXTERNAL_COURSE_CERTIFICATES_LOADING, { loading }),
  destroyCertificates: (payload: DestroyExternalCourseCertificatesPayload) =>
    createAction(DESTROY_EXTERNAL_COURSE_CERTIFICATES, payload),
}

export type Actions = ActionsUnion<typeof Actions>
